import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import styles from './DeliveriesOtpTracker.module.less';
import ActiveDeliveryOtps from '../../components/ActiveDeliveryOtps/ActiveDeliveryOtps';
import PastDeliveryOtps from '../../components/PastDeliveryOtps/PastDeliveryOtps';

const { TabPane } = Tabs;

export const DeliveriesOtpTracker = ({ activeDeliveryOtps, fetchActiveDeliveryOtps }) => {
  const activeDeliveryOtpsLength = activeDeliveryOtps.length;
  const { t } = useTranslation();
  return (
    <Tabs defaultActiveKey="active_otps" size="large" className={styles.container}>
      <TabPane
        tab={t('deliveryOtps.activeDeliveryOtpsTitle', { count: activeDeliveryOtpsLength })}
        key="active_otps"
        className={styles.tab}
      >
        <ActiveDeliveryOtps activeDeliveryOtps={activeDeliveryOtps} fetchActiveDeliveryOtps={fetchActiveDeliveryOtps} />
      </TabPane>
      <TabPane tab={t('deliveryOtps.pastDeliveryOtpsTitle')} key="past_otps" className={styles.tab}>
        <PastDeliveryOtps />
      </TabPane>
    </Tabs>
  );
};

DeliveriesOtpTracker.propTypes = {
  activeDeliveryOtps: PropTypes.arrayOf(PropTypes.any).isRequired,
  fetchActiveDeliveryOtps: PropTypes.func
};

export class DeliveriesOtpTrackerContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { activeDeliveryOtps, fetchActiveDeliveryOtps } = this.props;
    return (
      <DeliveriesOtpTracker activeDeliveryOtps={activeDeliveryOtps} fetchActiveDeliveryOtps={fetchActiveDeliveryOtps} />
    );
  }
}

DeliveriesOtpTrackerContainer.propTypes = {
  activeDeliveryOtps: PropTypes.arrayOf(PropTypes.any),
  fetchActiveDeliveryOtps: PropTypes.func
};

const mapState = ({ deliveryOtps: { activeDeliveryOtps } }) => ({
  activeDeliveryOtps
});

const mapDispatch = ({ deliveryOtps: { fetchActiveDeliveryOtps } }) => ({
  fetchActiveDeliveryOtps
});

export default connect(mapState, mapDispatch)(DeliveriesOtpTrackerContainer);
